export default "<router-outlet>\r\n  <ngx-ui-loader></ngx-ui-loader>\r\n</router-outlet>"